<script lang="ts">
export default {
  name: 'AccountWarning',
}
</script>

<script setup lang="ts">
import { AccountSummary, accountSummaryWarnings } from '@/types/AccountSummary';
import { ref, computed } from 'vue';
import { TriangleAlert } from 'lucide-vue-next';

const props = defineProps<{
  account: AccountSummary;
}>();

const show = ref(false);

const warnings = computed(() => {
  return accountSummaryWarnings(props.account);
});
</script>

<template>
  <v-dialog v-model="show" v-if="warnings.length > 0" max-width="500">
    <template v-slot:activator="{ props: activatorProps }">
      <triangle-alert
        v-bind="activatorProps"
        class="tw:h-4 tw:w-4 tw:cursor-pointer tw:text-warning"
        @click="show = true" />
    </template>
    <v-card :title="`${account.accountName} Warnings`">
      <v-card-text>
        <p class="tw:pb-3 tw:text-sm">This account has the following warnings:</p>
        <ul class="tw:px-8 tw:text-sm">
          <li v-for="warning in warnings" :key="warning">
            {{ warning }}
          </li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn variant="flat" size="small" @click="show = false">Cancel</v-btn>
        <v-btn variant="flat" size="small" color="primary" :to="`/account/${account.accountID}/edit`">Edit Account</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
